"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../../Firestore-Query/keyFactory");
/**
 *
 * @param options Opciones de react-query como ``enable``` o ```select```
 * @returns services enabled or disabled of selected corporates
 */
/**
 * Obtiene si el corporate esta activo de corporate/${corporate}/services/active
 */
function useCorporate(firestore, corporate, options) {
    const corporateRef = (0, firestore_2.doc)(firestore, `corporate/${corporate}/services/active`);
    return (0, firestore_1.useFirestoreDocumentData)(keyFactory_1.FirestoreKeys.Corporate({
        name: "corporateActive",
        path: `corporate/${corporate}/services/active`
    }, [corporate]), corporateRef, options, {
        select: (data) => data
    });
}
exports.default = useCorporate;
